
import fa from './fa';
import ding from './ding';
export default {
    path: 'projectflow',
    component: () => import(/*webpackChunkName: 'bidding-project'*/ '@layout/empty'),
    children: [
        fa,
        ding,
    ]
}